class ProductFeature extends HTMLElement {
  static selectors = {
    dialog: '[data-dialog]',
    openButton: '[data-open-dialog]',
    closeButton: '[data-close-dialog]',
    content: '[data-dialog-content]',
  };

  constructor() {
    super();
    this.dialog = null;
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  init() {
    const { dialog, openButton, closeButton, content } = ProductFeature.selectors;
    this.dialog = this.querySelector(dialog);
    if (!this.dialog) return;

    const { signal } = this.controller;

    const openBtn = this.querySelector(openButton);
    if (openBtn) {
      openBtn.addEventListener(
        'click',
        (e) => {
          if (e.target.closest('dialog') || window.matchMedia('(min-width: 990px)').matches) return;
          this.openDialog();
        },
        { signal }
      );
    }

    this.dialog.addEventListener(
      'click',
      (e) => {
        const isOutside = !e.target.closest(content);
        const isCloseBtn = e.target.closest(closeButton);
        if (isOutside || isCloseBtn) {
          this.closeDialog();
        }
      },
      { signal }
    );
  }

  openDialog() {
    this.dialog?.showModal();
  }

  closeDialog() {
    this.dialog?.close();
  }
}

if (!customElements.get('product-feature')) {
  customElements.define('product-feature', ProductFeature);
}
